/**
 * Grundlagen des Gebäudes.
 * Planachsen: x = von links (Garagenseite) nach rechts (Nachbar Nr. 32), 0…7,75 m
 *             y = von Straße (vorne) nach Garten (hinten), 0…11,00 m
 * Welt (Three.js): X = x, Y = Höhe, Z = −y
 */
export interface FloorDef { id: string; name: string; z: number; h: number }

export const FLOORS: FloorDef[] = [
  { id: "UG", name: "Untergeschoss", z: 0.0, h: 2.6 },
  { id: "EG", name: "Erdgeschoss", z: 2.6, h: 2.75 },
  { id: "OG", name: "Obergeschoss", z: 5.35, h: 2.75 },
  { id: "DG", name: "Dachgeschoss", z: 8.1, h: 3.42 },
];

export const RIDGE_Y = 5.5;
export const RIDGE_Z = 11.52;
export const ROOF_ANGLE = (30 * Math.PI) / 180;
export const SLOPE = Math.tan(ROOF_ANGLE);
export const ROOF_T = 0.25;
export const zTop = (y: number) => RIDGE_Z - SLOPE * Math.abs(y - RIDGE_Y);
export const zUnder = (y: number) => zTop(y) - ROOF_T / Math.cos(ROOF_ANGLE);
export const GARDEN_Z = 2.45;
export const WELL = { x0: 6.13, x1: 7.45, y0: 2.07, y1: 5.52 };
/** Garagen-Rückwand (außen) = Hausrückseite */
export const GB = 11.0;
/** oberes Ende der Außentreppe neben der Garage */
export const ST = GB + 14 * 0.307;

/** Fußbodenhöhe an einer Stelle (Terrasse auf der Garage, Garten, Balkon liegen anders als das Geschoss). */
export function floorBase(f: number, x: number, y: number): number {
  if (f === 1 && (y > 10.7 || (x < 0 && y > GB))) return GARDEN_Z + 0.02;
  if (f === 1 && x < 0) return 2.606;
  if (f === 2 && y > 10.7) return 5.35;
  return FLOORS[f].z;
}

/** Rechteck im Grundriss [x0, y0, x1, y1] – für Kollision und Abstände */
export type Rect = [number, number, number, number];
